import React from 'react';
import dayjs from 'core/utils/dayjs';
import OfferOverlayLink from 'core/modules/OfferOverlayLink/OfferOverlayLink';
import MerchantRebateV2 from 'core/modules/MerchantRebateV2/MerchantRebateV2';
import FavoriteIcon from 'core/modules/FavoriteIcon/FavoriteIcon';
import ReadMore from 'core/modules/ReadMore/ReadMore';
import {
  addPeriodAfterOfferRolloverCopy,
} from 'core/utils/apis/responseParsers/commonParsers/addPeriodAfterOfferRolloverCopy';

import './OfferTextItem.scss';

// Limit offer's text to fit into layout
const MAX_TEXT_LENGTH = 120;

function OfferTextItem({
  dataItem,
  sectionId,
  donotShowOngoingLanguage,
  maxTextLength = MAX_TEXT_LENGTH,
  className,
  rebateOptions,
  useExpiredDate,
}) {
  const {
    id,
    assets: { text },
    stopDatetime,
    merchant,
    couponCode,
    isOngoing,
  } = dataItem;

  const {
    id: merchantId, rebate, name, logoUrls: {
      _88x31,
    },
  } = merchant;

  const endDate = dayjs.parseZone(stopDatetime).format('MM/DD/YY');
  const expiredDate = dayjs.parseZone(stopDatetime).format('MMM DD, YYYY');
  const useOngoingLanguage = !donotShowOngoingLanguage && isOngoing;
  const customRebateOptions = { hideRebatePrefix: true, hideElevationCurrency: true, ...rebateOptions };
  const textFormatted = addPeriodAfterOfferRolloverCopy(text);

  return (
    <div
      className={`mn_textOffer ${className || ''}`}
      data-test="offer-table-item"
      data-section-type={sectionId}
      data-merchant-name={name}
      data-merchant-id={merchantId}
      data-offer-id={id}
      data-offer-text={text}
      role="listitem"
    >
      <div className="mn_offerFavoritesWrap">
        <FavoriteIcon merchantId={merchantId} merchantName={name} />
      </div>
      <OfferOverlayLink merchantId={merchantId} merchantName={name} offerId={id} sectionId={sectionId}>
        <div className="mn_offerMrch">
          <img src={_88x31} alt={name} />
        </div>
        <div className="mn_offerItemContent">
          <div className="mn_offerDet">
            {useExpiredDate ? (
              <ReadMore
                data-test="offer-item-text"
                text={textFormatted}
                moreLinkText="More"
                maxTextLength={maxTextLength}
              >
                <span className="mn_expired">
                  {useOngoingLanguage ? (
                    <span data-test="offer-item-expiry-text" className="mn_expiredPrefix">&nbsp;Ongoing</span>) :
                    <span
                      data-test="offer-item-expiry-text"
                      className="mn_expiredPrefix"
                    >
                      &nbsp;Valid through {expiredDate}
                    </span>
                  }
                </span>
              </ReadMore>
            ) : (
              <ReadMore
                data-test="offer-item-text"
                text={text}
                moreLinkText="More"
                maxTextLength={maxTextLength}
              >
                <span className="mn_expiry">
                  {useOngoingLanguage ? (
                    <span data-test="offer-item-expiry-text" className="mn_expirePrefix">&nbsp;Ongoing</span>) :
                    <span
                      data-test="offer-item-expiry-text"
                      className="mn_expirePrefix"
                    >
                      &nbsp;Valid thru: {endDate}
                    </span>
                  }
                </span>
              </ReadMore>
            )}
          </div>
          <MerchantRebateV2 {...rebate} {...customRebateOptions} />
          {couponCode &&
            <div className="mn_codeWrap">
              <div className="mn_codeInfo" data-test="coupon-code">
                <span className="mn_codeLabel">With promo:&nbsp;</span>
                <span className="mn_copyCouponCode">
                  {couponCode}
                </span>
              </div>
            </div>
          }
        </div>
      </OfferOverlayLink>
    </div>
  );
}

export default OfferTextItem;
